import { Dropdown, DropdownItem } from '@flixbus/honeycomb-react';

import styles from './styles.module.css';

const WorkAssignmentActionMenu = ({
	items = [],
	isLoading,
	children,
	active = false,
	onToggle = () => {},
}) => {
	if (!items || items.length === 0 || !children) return null;

	const actionItems = items.map((item, index) => {
		if (item.divider) {
			return <DropdownItem key={`action-divider-${item.id ?? index}`} divider />;
		}

		return (
			<DropdownItem
				key={`action-${item.label}${index}`}
				Elem="button"
				onClick={() => {
					if (item.disabled || isLoading) return;
					item.action();
					onToggle(false);
				}}
				disabled={isLoading || item.disabled}
			>
				{item.label}
			</DropdownItem>
		);
	});

	return (
		<div onClick={(e) => e.stopPropagation()} className={styles.menu}>
			<Dropdown
				active={active}
				onToggle={onToggle}
				xPosition="left"
				yPosition="bottom"
				links={actionItems}
			>
				{children}
			</Dropdown>
		</div>
	);
};

export default WorkAssignmentActionMenu;
